import { render, staticRenderFns } from "./DiscrepancyReportDetailsView.vue?vue&type=template&id=92fe35c6"
import script from "./DiscrepancyReportDetailsView.vue?vue&type=script&lang=js"
export * from "./DiscrepancyReportDetailsView.vue?vue&type=script&lang=js"
import style0 from "./DiscrepancyReportDetailsView.vue?vue&type=style&index=0&id=92fe35c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports